import {Component, inject, OnInit, Signal} from '@angular/core';
import { CommonModule } from '@angular/common';
import { LbChartWrapperComponent } from "../../toolbox/charts/lb-chart-wrapper/lb-chart-wrapper.component";
import { Chart } from "../shared.interface";
import {LbDashboardIconCardComponent} from "../lb-dashboard-icon-card/lb-dashboard-icon-card.component";
import { faUser, faShop, faTag, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {toSignal} from "@angular/core/rxjs-interop";
import {BehaviorSubject, map} from "rxjs";
import {MediaQueryService} from "../../../services/media-query/media-query.service";
import { Input } from '@angular/core';

@Component({
  selector: 'app-lb-dashboard-overview',
  standalone: true,
  imports: [CommonModule, LbChartWrapperComponent, LbDashboardIconCardComponent],
  templateUrl: './lb-dashboard-overview.component.html',
  styleUrls: ['./lb-dashboard-overview.component.scss']
})
export class LbDashboardOverviewComponent {
  constructor(private http:HttpClient) {}
  private mediaService: MediaQueryService = inject(MediaQueryService);
  public isMobile: Signal< boolean > = toSignal(this.mediaService.getDisplayType().pipe(map(({isMobile}) => isMobile)), {initialValue: window.innerWidth < 768});

  @Input() sqa_list: any = undefined;

  faUser = faUser
  faShop = faShop
  faTag = faTag
  faLocationDot = faLocationDot
  metrics:any = {
    respondents:undefined,
    retailers:undefined,
    vendors:undefined,
    countries:undefined
  }

  charts_row_2: Chart[] = []
  charts_row_3: Chart[] = []
  loadedData: BehaviorSubject<boolean> = new BehaviorSubject(false)

    ngOnInit() {
      let url = environment.backend_base+'lb/get_dashboard_data/'
      let data = {sqa_list : this.sqa_list}
      this.http.post(url, data).subscribe((response:any) => {
        this.metrics = response.data
      })

      this.charts_row_2 = [
        {
          sqa: this.sqa_list[0],
          style: 'width:38vw;',
        },
        {
          sqa: this.sqa_list[1],
          style: 'width:38vw'
        },
      ]

      this.charts_row_3 = [
        {
          sqa: this.sqa_list[2],
          style: 'width:75vw'
        }]

        // console.log(this.charts_row_2)
        this.loadedData.next(true)

    }
}



